<script setup lang="ts">
import { ref } from "vue";
import Announcements from "@/domains/home/services/configurations/views/mobile/tabs/Announcements.vue";
import ServiceCentres from "@/domains/home/services/configurations/views/mobile/tabs/ServiceCentres.vue";
import URSBService from "@/domains/home/services/configurations/views/mobile/tabs/URSBService.vue";
import MobileAppKeys from "@/domains/home/services/configurations/views/mobile/tabs/MobileAppKeys.vue";

const currentRoute = ref<string>("service-centres");

const select = (route: string) => {
  currentRoute.value = route;
};
</script>

<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-2">
        <div
          :class="[(currentRoute === 'service-centres') ? 'menu-pill-active' : 'menu-pill']"
          @click="select('service-centres')"
        >
          <div class="flex">
            <div>Service centres</div>
          </div>
        </div>
        <div
          :class="[(currentRoute === 'ursb-services') ? 'menu-pill-active' : 'menu-pill']"
          @click="select('ursb-services')"
        >
          <div class="flex">
            <div>URSB Services</div>
          </div>
        </div>
        <div
          :class="[(currentRoute === 'announcements') ? 'menu-pill-active' : 'menu-pill']"
          @click="select('announcements')"
        >
          <div class="flex">
            <div>Announcements</div>
          </div>
        </div>
        <div
          :class="[(currentRoute === 'mobile-app-keys') ? 'menu-pill-active' : 'menu-pill']"
          @click="select('mobile-app-keys')"
        >
          <div class="flex">
            <div>Mobile App Keys</div>
          </div>
        </div>
      </div>
      <div class="col-span-10">
        <ServiceCentres v-if="currentRoute === 'service-centres'" />
        <URSBService v-if="currentRoute === 'ursb-services'" />
        <Announcements v-if="currentRoute === 'announcements'" />
        <MobileAppKeys v-if="currentRoute === 'mobile-app-keys'" />
      </div>
    </div>
  </div>
</template>
